import React, { useState, useEffect, useRef } from "react";
import { SocialShare } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";
import { object, string, bool, func } from "prop-types";

import SocialShareTemplate from "../SocialShareTemplate";
import { FontIncrease, FontDecrease, CommentIcon, Share } from "../../atoms/icons/StoryPageIcons";
import { setMetypeBar } from "../../helper/actions";
import ShareAllTemplate from "../ShareAllTemplate";
import BookmarkViewIcon from "../../atoms/BookmarkViewIcon";
import { fontVariation } from "../../utils/utils";
import MetypeCommentWrapper from "../../MetypeComments";

import "./storyPageMetaDataIcons.m.css";

const StoryPageMetaDataIcons = ({
  storyData,
  color1 = "#eee",
  color2 = "#222",
  isMetypeBar,
  setMetypeBar,
  isVideoStory,
  publisherAttributes,
  member,
  authHost,
  jwtToken,
  metypeConfig,
}) => {
  const [elements, setElements] = useState(null);
  const [customGalleryElements, setCustomGalleryElements] = useState(null);
  const [isSocialShare, setSocialShare] = useState(false);
  const ref = useRef(null);
  const metypeRef = useRef(null);
  const commentIconRef = useRef(null);
  const [metypeTarget, setMetypeTarget] = useState(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setSocialShare(false);
    }
  };

  const renderMetype = () => {
    const targetNode = commentIconRef.current.id;
    setMetypeTarget(targetNode);
    setMetypeBar({ isMetypeBar: !isMetypeBar });
  };

  const toggleShare2 = () => {
    setSocialShare(!isSocialShare);
  };

  useEffect(() => {
    if (global.deviceWidth > 876) {
      document.addEventListener("click", handleClickOutside, true);
      return () => {
        document.removeEventListener("click", handleClickOutside, true);
      };
    }
  });

  useEffect(() => {
    const paraElements = document.getElementsByTagName("P");
    const anchorElements = document.getElementsByTagName("A");
    const h1Elements = document.getElementsByTagName("H1");
    const h2Elements = document.getElementsByTagName("H2");
    const spanElements = document.getElementsByTagName("SPAN");
    const figCaptionElements = document.getElementsByTagName("FIGCAPTION");
    const blockQuoteElements = document.getElementsByTagName("BLOCKQUOTE");
    const htmlElements = Array.from(paraElements).concat(
      Array.from(anchorElements),
      Array.from(h1Elements),
      Array.from(h2Elements),
      Array.from(spanElements),
      Array.from(figCaptionElements),
      Array.from(blockQuoteElements)
    );
    setElements(htmlElements);
  }, [storyData]);

  useEffect(() => {
    setCustomGalleryElements(document.getElementsByClassName("custom-galley-image"));
  }, []);

  return (
    <div styleName="icons" className="meta-data-icons">
      <SocialShare
        template={SocialShareTemplate}
        title={storyData.headline}
        fullUrl={encodeURI(storyData.url)}
        color1={color1}
        color2={color2}
      />
      <span styleName="share-button" ref={ref}>
        <span onClick={toggleShare2}>
          <Share color1={color1} color2={color2} />
        </span>
        {isSocialShare && (
          <SocialShare
            template={ShareAllTemplate}
            title={storyData.headline}
            fullUrl={encodeURI(storyData.url)}
            toggleShare2={toggleShare2}
            onScroll={true}
          />
        )}
      </span>
      {!isVideoStory && (
        <span
          onClick={(e) => fontVariation("add", elements, customGalleryElements, publisherAttributes.lang)}
          className="font-increase"
        >
          <FontIncrease className="font-increase" lang={publisherAttributes.lang} />
        </span>
      )}
      {!isVideoStory && (
        <span
          onClick={(e) => fontVariation("minus", elements, customGalleryElements, publisherAttributes.lang)}
          className="font-decrease"
        >
          <FontDecrease className="font-decrease" lang={publisherAttributes.lang} />
        </span>
      )}
      {publisherAttributes.showBookmark && (
        <span className="bookmark">
          <BookmarkViewIcon story={storyData.story} color1={color1} color2={color2} />
        </span>
      )}
      {publisherAttributes.showMetype && (
        <span className="comment-icon" ref={commentIconRef} onClick={renderMetype} id={storyData.id}>
          <CommentIcon className="comment-icon" />
        </span>
      )}
      <div ref={metypeRef} className={storyData.id}>
        {publisherAttributes.showMetype &&
          isMetypeBar &&
          metypeTarget === get(metypeRef, ["current", "classList", "value"], "") && (
            <MetypeCommentWrapper
              metypeConfig={metypeConfig}
              storyUrl={storyData.url}
              metype={isMetypeBar}
              onToggleMetype={renderMetype}
              jwtToken={jwtToken}
              authHost={authHost}
              lang={publisherAttributes.lang}
              member={member}
            />
          )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  storyData: get(state, ["headerReducer", "showStoryHeader"], {}),
  isMetypeBar: get(state, ["metypeReducer", "isMetypeBar"], false),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  member: state.member,
  authHost: get(state, ["qt", "config", "publisher-attributes", "auth_host"], null),
  jwtToken: get(state, ["userReducer", "jwt_token"], null),
  metypeConfig: get(state, ["qt", "config", "publisher-attributes", "metypeConfig"], {}),
});

const mapDispatchToProps = (dispatch) => ({
  setMetypeBar: (flag) => dispatch(setMetypeBar(flag)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StoryPageMetaDataIcons);

StoryPageMetaDataIcons.propTypes = {
  storyData: object,
  color1: string,
  color2: string,
  isMetypeBar: bool,
  isVideoStory: bool,
  setMetypeBar: func,
  publisherAttributes: object,
  member: object,
  authHost: string,
  jwtToken: string,
  metypeConfig: object,
};
